/* eslint-disable @typescript-eslint/no-explicit-any */
export const styleConfig: any = {
  buttonStackDirection: { base: 'column', md: 'row' },
  buttonWidth: { base: '100%', md: '50%' },
};
